import { render, staticRenderFns } from "./OrderDetailsSeller.vue?vue&type=template&id=599f8e74&scoped=true"
import script from "./OrderDetailsSeller.vue?vue&type=script&lang=js"
export * from "./OrderDetailsSeller.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsSeller.vue?vue&type=style&index=0&id=599f8e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f8e74",
  null
  
)

export default component.exports